import React from "react"
import types from "./types"

export default props => {
  const { __typename, ...rest } = props
  const QuestionType = types[__typename.replace("Sanity", "")]
  return QuestionType ? <QuestionType {...rest} /> : null
}
